import React from 'react';
import {
  Stack, Chip, Paper, Table, TableHead, TableRow, TableCell, TableBody,
  TableContainer, TextField, Skeleton, Typography
} from '@mui/material';
import { ReconcileAction, ACTION_LABELS } from '../Data/enums';

const actionColor = (a) => {
  switch (a) {
    case ReconcileAction.CONTINUE: return 'success';
    case ReconcileAction.MODIFY:   return 'warning';
    case ReconcileAction.STOP:     return 'error';
    case ReconcileAction.NEW:      return 'info';
    default: return 'default';
  }
};

export default function SummaryCard({ summary, notes, onNotesChange, loading }) {
  if (loading) return <Skeleton variant="rounded" height={220} />;

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2}>
        <Chip label={`Total: ${summary.total}`} />
        <Chip color="success" label={`Continue: ${summary.CONTINUE}`} />
        <Chip color="warning" label={`Modify: ${summary.MODIFY}`} />
        <Chip color="error"   label={`Stop: ${summary.STOP}`} />
        <Chip color="info"    label={`New: ${summary.NEW}`} />
      </Stack>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ '& th': { backgroundColor: '#607d8b', color: '#fff', fontWeight: 'bold' } }}>
              <TableCell>Medication</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
              <TableCell>Reason</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {summary.items.map((it, idx) => (
              <TableRow
                key={it.key}
                sx={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f5f5f5', '&:hover': { backgroundColor: '#e3f2fd' } }}
              >
                <TableCell>{it.name}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    color={actionColor(it.action)}
                    label={ACTION_LABELS[it.action] || it.action}
                  />
                </TableCell>
                <TableCell>
                  {it.from ? `${it.from.dose} • ${it.from.route} • ${it.from.frequency}` : '—'}
                </TableCell>
                <TableCell>
                  {it.to ? `${it.to.dose} • ${it.to.route} • ${it.to.frequency}` : '—'}
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ fontStyle: it.reason ? 'normal' : 'italic', color: it.reason ? 'text.primary' : 'text.disabled' }}>
                    {it.reason || 'No reason provided'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
            {summary.items.length === 0 && (
              <TableRow><TableCell colSpan={5} align="center">No results</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TextField
        multiline minRows={3} label="Final notes"
        value={notes} onChange={(e) => onNotesChange?.(e.target.value)}
      />
    </Stack>
  );
}
